
import React, { useState, useEffect } from 'react';
import { invoicesAPI } from '../services/api';
import { useNavigate } from 'react-router-dom';

const AddInvoice: React.FC = () => {
  const navigate = useNavigate();
  const [invoiceNumber, setInvoiceNumber] = useState('');
  const [clientId, setClientId] = useState('');
  const [projectId, setProjectId] = useState('');
  const [amount, setAmount] = useState('');
  const [status, setStatus] = useState('Pending');
  const [dueDate, setDueDate] = useState('');
  const [issueDate, setIssueDate] = useState('');
  const [description, setDescription] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  // TODO: Fetch clients and projects for dropdowns
  const [clients, setClients] = useState<{ _id: string; company: string }[]>([]);
  const [projects, setProjects] = useState<{ _id: string; name: string }[]>([]);

  useEffect(() => {
    import('../services/api').then(({ clientsAPI }) => {
      clientsAPI.getAll().then((res: any) => setClients(res.data));
    });
  }, []);

  useEffect(() => {
    if (!clientId) {
      setProjects([]);
      return;
    }
    import('../services/api').then(({ projectsAPI }) => {
      projectsAPI.getByClient(clientId).then((res: any) => setProjects(res.data));
    });
  }, [clientId]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');
    try {
      await invoicesAPI.create({
        invoiceNumber,
        clientId,
        projectId,
        amount: Number(amount),
        status,
        dueDate,
        issueDate,
        description,
      });
      setMessage('Invoice added successfully!');
      setInvoiceNumber('');
      setClientId('');
      setProjectId('');
      setAmount('');
      setStatus('Pending');
      setDueDate('');
      setIssueDate('');
      setDescription('');
    } catch (err) {
      setMessage('Failed to add invoice.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-lg mx-auto p-8 bg-white rounded shadow mt-8">
      <h2 className="text-xl font-bold mb-6">Add Invoice</h2>
  <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-sm font-medium mb-1">Invoice Number</label>
          <input type="text" value={invoiceNumber} onChange={e => setInvoiceNumber(e.target.value)} className="w-full border rounded px-3 py-2" required />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Client</label>
          <select value={clientId} onChange={e => setClientId(e.target.value)} className="w-full border rounded px-3 py-2" required>
            <option value="">Select Client</option>
            {clients.map(c => (
              <option key={c._id} value={c._id}>{c.company}</option>
            ))}
          </select>
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Project</label>
          <select value={projectId} onChange={e => setProjectId(e.target.value)} className="w-full border rounded px-3 py-2">
            <option value="">Select Project</option>
            {projects.map(p => (
              <option key={p._id} value={p._id}>{p.name}</option>
            ))}
          </select>
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Amount</label>
          <input type="number" value={amount} onChange={e => setAmount(e.target.value)} className="w-full border rounded px-3 py-2" required />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Status</label>
          <select value={status} onChange={e => setStatus(e.target.value)} className="w-full border rounded px-3 py-2">
            <option value="Pending">Pending</option>
            <option value="Paid">Paid</option>
            <option value="Overdue">Overdue</option>
          </select>
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Due Date</label>
          <input type="date" value={dueDate} onChange={e => setDueDate(e.target.value)} className="w-full border rounded px-3 py-2" required />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Issue Date</label>
          <input type="date" value={issueDate} onChange={e => setIssueDate(e.target.value)} className="w-full border rounded px-3 py-2" />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Description</label>
          <textarea value={description} onChange={e => setDescription(e.target.value)} className="w-full border rounded px-3 py-2" rows={3} />
        </div>

        <div className="flex justify-between mt-4">
          <button
            type="button"
            className="bg-gray-200 text-gray-700 px-4 py-2 rounded hover:bg-gray-300 mr-2"
            onClick={() => navigate("/finance?tab=invoices")}
          >
            Back
          </button>
          <button
            type="submit"
            className="bg-blue-600 text-white px-4 py-2 rounded shadow hover:bg-blue-700 transition"
            disabled={loading}
          >
            {loading ? "Adding..." : "Add Invoice"}
          </button>
        </div>
      {message && <div className="mt-4 text-center text-green-600">{message}</div>}
    </form>
  </div>
  );
};

export default AddInvoice;
